export enum PhoneNumberType {
  INTERNAL = 'INTERNAL',
  CORPORATE = 'CORPORATE',
  FIXED_NETWORK = 'FIXED_NETWORK',
  MSISDN = 'MSISDN',
  FAX = 'FAX',
  VOICEMAIL = 'VOICEMAIL',
  UNKNOWN = 'UNKNOWN',
}
